export default __webpack_public_path__ + "images/b7313c0e60ccb5e772442ea39f8448e4-dating_tablet_2_1067x312.webp";